<template>
  <div>
      <ed-modelo :intTipoModeloId="320" :key="$root.$session.versao" :intId="0" strParametro="consultaGrupo"/>
  </div>
</template>

<script>
import EdModelo from "@/components/documento/modelo/editar";
export default {
  name: "pageCadastroEmpresa",
  props: {},
  components: { EdModelo },
  mounted() {
  },
  created() {},
  data() {
    return {};
  },
  methods: {},
};
</script>